/**
 * GZOO AI Marketing - Frontend
 * API Client Configuration
 */

import axios from 'axios';
import { installAuthInterceptors } from './authSession';

// API base URL from environment or default
const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8000/api/v1';

// Create axios instance with default config
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // For cookie-based auth
  timeout: 60000, // 60 second timeout — saves with MJML rendering + scoring can take time
});

// Bearer-token attach + single-flight refresh + transient-network retry + safe logout.
// See lib/api/authSession.ts for the shared behavior (kept identical across every axios client).
installAuthInterceptors(apiClient);

export default apiClient;
